<!----------------------------------- Menu ---------------------------------------->
<div class="tds-row tds-u-mt2 tds-u-mb02">
    <div class="no-padding tds-col-xxlg-3 tds-col-xlg-4 tds-col-lg-4 tds-u-mb1" style="white-space: nowrap;">
        <tds-text-field [(ngModel)]="searchString"
            (tdsInput)="onQuickFilterInput($event)"
            ngDefaultControl
            type="Text"
            size="md"
            state="default"
            label="Quick Filter"
            label-position="inside"
            placeholder="Ex. (part of) Assignment nr, Department etc.">
        </tds-text-field>
    </div>

    <div class="no-padding tds-col-xxlg-2 tds-col-xlg-4 tds-col-lg-4 tds-u-pt2 tds-u-mb1" style="white-space: nowrap;">
        <tds-toggle color="primary"
            [checked]="showOnlyMyConsultants"
            (tdsToggle)="showOnlyMyConsultantsChecked($event)"
            [disabled]="hideOtherDepts"
            size="sm">
            <div style="cursor: pointer;" slot="label">
                My Consultants
            </div>
        </tds-toggle>
    </div>

    <div class="no-padding tds-col-xxlg-7 tds-col-xlg-4 tds-col-lg-4 tds-u-pt2 tds-u-mb1" style="white-space: nowrap;">
        <tds-toggle color="primary"
            [checked]="hideOtherDepts"
            (tdsToggle)="hideOtherDeptsChecked($event)"
            [disabled]="showOnlyMyConsultants"
            size="sm">
            <div style="cursor: pointer;" slot="label">
                My Department
            </div>
        </tds-toggle>
    </div>

    <div class="no-padding tds-col-xxlg-2 tds-col-xlg-3 tds-col-lg-3 tds-u-mb1" style="white-space: nowrap;">
        <tds-toggle color="primary"
            [checked]="hideInactive"
            (tdsToggle)="hideInactiveChecked($event)"
            [disabled]="showOnlyEnded || showOnlyExpired"
            size="sm">
            <div style="cursor: pointer;" *ngIf="!(showOnlyEnded || showOnlyExpired)" slot="label">
                Hide Inactive
            </div>
            <div *ngIf="showOnlyEnded || showOnlyExpired" slot="label" style="opacity: 0.5">
                Hide Inactive
            </div>
        </tds-toggle>
    </div>

    <div class="no-padding tds-col-xxlg-2 tds-col-xlg-3 tds-col-lg-3 tds-u-mb1" style="white-space: nowrap;">
        <tds-toggle color="primary"
            [checked]="showOnlyExpired"
            (tdsToggle)="showOnlyExpiredChecked($event)"
            [disabled]="showOnlyEnded || hideInactive"
            size="sm">
            <div style="cursor: pointer;" *ngIf="!(showOnlyEnded || hideInactive)" slot="label">
                Expired Only
            </div>
            <div *ngIf="showOnlyEnded || hideInactive" slot="label" style="opacity: 0.5">
                Expired Only
            </div>
        </tds-toggle>
    </div>

    <div class="no-padding tds-col-xxlg-2 tds-col-xlg-3 tds-col-lg-3 tds-u-mb1" style="white-space: nowrap;">
        <tds-toggle color="primary"
            [checked]="showOnlyEnded"
            (tdsToggle)="showOnlyEndedChecked($event)"
            [disabled]="showOnlyExpired || hideInactive"
            size="sm">
            <div style="cursor: pointer;" *ngIf="!(showOnlyExpired || hideInactive)" slot="label">
                Inactive Only
            </div>
            <div *ngIf="showOnlyExpired || hideInactive" slot="label" style="opacity: 0.5">
                Inactive Only
            </div>
        </tds-toggle>
    </div>

    <div class="no-padding tds-col-xxlg-2 tds-col-xlg-3 tds-col-lg-3 tds-u-mb1" style="white-space: nowrap;">
        <tds-toggle color="primary"
            [checked]="showOnlyWithActiveConsultants"
            (tdsToggle)="showOnlyWithActiveConsultantsChecked($event)"
            [disabled]="showOnlyWithoutConsultants"
            size="sm">
            <div style="cursor: pointer;" *ngIf="!showOnlyWithoutConsultants" slot="label">
                Active Consultants Only
            </div>
            <div *ngIf="showOnlyWithoutConsultants" slot="label" style="opacity: 0.5">
                Active Consultants Only
            </div>
        </tds-toggle>
    </div>

    <div class="no-padding tds-col-xxlg-2 tds-col-xlg-3 tds-col-lg-3 tds-u-mb1" style="white-space: nowrap;">
        <tds-toggle color="primary"
            [checked]="showOnlyWithoutConsultants"
            (tdsToggle)="showOnlyWithoutConsultantsChecked($event)"
            [disabled]="showOnlyWithActiveConsultants"
            size="sm">
            <div style="cursor: pointer;" *ngIf="!showOnlyWithActiveConsultants" slot="label">
                Without Consultants Only
            </div>
            <div *ngIf="showOnlyWithActiveConsultants" slot="label" style="opacity: 0.5">
                Without Consultants Only
            </div>
        </tds-toggle>
    </div>

    <div class="no-padding tds-col-xxlg-2 tds-col-xlg-9 tds-col-lg-9 tds-u-mb1" style="white-space: nowrap;">
        <tds-toggle color="primary"
            [checked]="advancedSearchbarOpen"
            (tdsToggle)="showAdvancedSearch($event)"
            size="sm">
            <div style="cursor: pointer;" *ngIf="!advancedSearchbarOpen" slot="label">
                Show Advanced Filter
            </div>
            <div *ngIf="advancedSearchbarOpen" slot="label">
                Hide Advanced Filter
            </div>
        </tds-toggle>
    </div>
</div>
<!----------------------------------- Menu End ---------------------------------------->

<!----------------------------------- Advanced Search Field ---------------------------------------->
<!-- advancedSearchbarOpen"  -->
<div *ngIf="this.advancedSearchbarOpen" >
    <div class="tds-u-ml2 tds-u-mb2"  style="width: 100%;">
        <div class="tds-headline-05 ">Filter assignments on one or more search criteria</div>
        <span class="tds-u-ml2" style="color:var(--tds-red-600)"
            title="Clear all advanced search fields"
            *ngIf="isAdvancedSearchActive()">
            <div  ass="tds-u-ml2"  style="cursor: pointer;position:absolute;" (click)="clearAdvancedSearchStrings()">
                Clear all <tds-icon slot="icon" size="20px" name="trash"></tds-icon>
            </div>
        </span>
    </div>

    <div class="inline tds-row">
        <div class="no-padding tds-col-xxlg-2 tds-col-xlg-2 tds-col-lg-2 tds-col-md-3 tds-col-sm-4 tds-col-xs-6 tds-u-mb1">
            <div title="Where consultant name CONTAINS search string">
                <tds-text-field [(ngModel)]="consNameSearch"
                    (ngModelChange)="filterTableData()"
                    ngDefaultControl
                    type="Text"
                    size="md"
                    state="default"
                    label="Consultant Name"
                    label-position="inside"
                    no-min-width>
                </tds-text-field>
            </div>
        </div>

        <div class="no-padding tds-col-xxlg-2 tds-col-xlg-2 tds-col-lg-2 tds-col-md-3 tds-col-sm-4 tds-col-xs-6 tds-u-mb1">
            <div title="Where consultant number CONTAINS search string">
                <tds-text-field [(ngModel)]="consNrSearch"
                    (ngModelChange)="filterTableData()"
                    ngDefaultControl
                    type="Text"
                    size="md"
                    state="default"
                    label="Consultant Number"
                    label-position="inside"
                    no-min-width>
                </tds-text-field>
            </div>
        </div>

        <div class="no-padding tds-col-xxlg-2 tds-col-xlg-2 tds-col-lg-2 tds-col-md-3 tds-col-sm-4 tds-col-xs-6 tds-u-mb1">
            <div title="Where consultant start date CONTAINS search string">
                <tds-text-field [(ngModel)]="consStartDateSearch"
                    (ngModelChange)="filterTableData()"
                    ngDefaultControl
                    type="Text"
                    size="md"
                    state="default"
                    label="Consultant Start Date"
                    label-position="inside"
                    no-min-width
                    placeholder="YYYYMMDD">
                </tds-text-field>
            </div>
        </div>

        <div class="no-padding tds-col-xxlg-2 tds-col-xlg-2 tds-col-lg-2 tds-col-md-3 tds-col-sm-4 tds-col-xs-6 tds-u-mb1">
            <div title="Where consultant end date CONTAINS search string">
                <tds-text-field [(ngModel)]="consEndDateSearch"
                    (ngModelChange)="filterTableData()"
                    ngDefaultControl
                    type="Text"
                    size="md"
                    state="default"
                    label="Consultant End Date"
                    label-position="inside"
                    no-min-width
                    placeholder="YYYYMMDD">
                </tds-text-field>
            </div>
        </div>

        <div class="no-padding tds-col-xxlg-2 tds-col-xlg-2 tds-col-lg-2 tds-col-md-3 tds-col-sm-4 tds-col-xs-6 tds-u-mb1">
            <div title="Where assignment number CONTAINS search string">
                <tds-text-field [(ngModel)]="assignNrSearch"
                    (ngModelChange)="filterTableData()"
                    ngDefaultControl
                    type="Text"
                    size="md"
                    state="default"
                    label="Assignment Number"
                    label-position="inside"
                    no-min-width>
                </tds-text-field>
            </div>
        </div>

        <div class="no-padding tds-col-xxlg-2 tds-col-xlg-2 tds-col-lg-2 tds-col-md-3 tds-col-sm-4 tds-col-xs-6 tds-u-mb1">
            <div title="Where assignment start date CONTAINS search string">
                <tds-text-field [(ngModel)]="assignStartDateSearch"
                    (ngModelChange)="filterTableData()"
                    ngDefaultControl
                    type="Text"
                    size="md"
                    state="default"
                    label="Assignment Start Date"
                    label-position="inside"
                    no-min-width
                    placeholder="YYYYMMDD">
                </tds-text-field>
            </div>
        </div>

        <div class="no-padding tds-col-xxlg-2 tds-col-xlg-2 tds-col-lg-2 tds-col-md-3 tds-col-sm-4 tds-col-xs-6 tds-u-mb1">
            <div title="Where assignment end date CONTAINS search string">
                <tds-text-field [(ngModel)]="assignEndDateSearch"
                    (ngModelChange)="filterTableData()"
                    ngDefaultControl
                    type="Text"
                    size="md"
                    state="default"
                    label="Assignment End Date"
                    label-position="inside"
                    no-min-width
                    placeholder="YYYYMMDD">
                </tds-text-field>
            </div>
        </div>

        <div class="no-padding tds-col-xxlg-2 tds-col-xlg-2 tds-col-lg-2 tds-col-md-3 tds-col-sm-4 tds-col-xs-6 tds-u-mb1">
            <div title="Where extend date CONTAINS search string">
                <tds-text-field [(ngModel)]="extendDateSearch"
                    (ngModelChange)="filterTableData()"
                    ngDefaultControl
                    type="Text"
                    size="md"
                    state="default"
                    label="Extend Date"
                    label-position="inside"
                    no-min-width
                    placeholder="YYYYMMDD">
                </tds-text-field>
            </div>
        </div>

        <div class="no-padding tds-col-xxlg-2 tds-col-xlg-2 tds-col-lg-2 tds-col-md-3 tds-col-sm-4 tds-col-xs-6 tds-u-mb1">
            <div title="Where unit number date EXACTLY MATCHES selected unit">
                <tds-dropdown
                    ngDefaultControl
                    name="dropdown"
                    label="Select Unit"
                    label-position="inside"
                    size="md"
                    default-value="All"
                    open-direction="auto">
                    <tds-dropdown-option value="{{unit.number}}" (click)="setUnitSearchValue(unit.number)" *ngFor="let unit of units" >
                        {{unit.number}}
                    </tds-dropdown-option>
                </tds-dropdown>                
                <!-- <select class="unit-select">
                    <option
                        class="tds-body-01"
                        (click)="setUnitSearchValue(unit)"  
                        *ngFor="let unit of units" > 
                        {{unit.number}}
                    </option>                 
                </select> -->
            </div>
        </div>

        <div class="no-padding tds-col-xxlg-2 tds-col-xlg-2 tds-col-lg-2 tds-col-md-3 tds-col-sm-4 tds-col-xs-6 tds-u-mb1">
            <div title="Where department STARTS WITH search string">
                <tds-text-field
                    [(ngModel)]="deptSearch"
                    (ngModelChange)="filterTableData()"
                    ngDefaultControl
                    type="Text"
                    size="md"
                    state="default"
                    label="Department"
                    label-position="inside"
                    no-min-width>
                </tds-text-field>
            </div>
        </div>

        <div class="no-padding tds-col-xxlg-2 tds-col-xlg-2 tds-col-lg-2 tds-col-md-3 tds-col-sm-4 tds-col-xs-6 tds-u-mb1">
            <div title="Where reason CONTAINS search string">
                <tds-text-field
                    [(ngModel)]="reasonSearch"
                    (ngModelChange)="filterTableData()"
                    ngDefaultControl
                    type="Text"
                    size="md"
                    state="default"
                    label="Reason"
                    label-position="inside"
                    no-min-width>
                </tds-text-field>
            </div>
        </div>

        <div class="no-padding tds-col-xxlg-2 tds-col-xlg-2 tds-col-lg-2 tds-col-md-3 tds-col-sm-4 tds-col-xs-6 tds-u-mb1">
            <div title="Where manager name CONTAINS search string">
                <tds-text-field
                    [(ngModel)]="managerSearch"
                    (ngModelChange)="filterTableData()"
                    ngDefaultControl
                    type="Text"
                    size="md"
                    state="default"
                    label="Manager Name"
                    label-position="inside"
                    no-min-width>
                </tds-text-field>
            </div>
        </div>
    </div>
</div>
<!----------------------------------- Advanced Search Field End ---------------------------------------->

<!------------------------------------Admin-Info-Messages---------------------------------------------->
<div class="tds-col-xs-12 tds-u-p1" *ngFor="let message of messages">
    <tds-message (click)="hideMessage(message.id)" *ngIf="message.header == 'IMPORTANT'" variant="error" header="{{message.header}}" 
        title="Click to hide">
        {{message.message}}<div class="tds-u-mt2" style="color:darkgray;">(Click message to hide)</div>
    </tds-message >
    <tds-message (click)="hideMessage(message.id)" *ngIf="message.header == 'ATTENTION'" variant="warning" header="{{message.header}}"
        title="Click to hide">
        {{message.message}}<div class="tds-u-mt2" style="color:darkgray;">(Click message to hide)</div>
    </tds-message >
    <tds-message (click)="hideMessage(message.id)"  *ngIf="message.header == 'INFORMATION'" variant="information" header="{{message.header}}"
        title="Click to hide">
        {{message.message}}<div class="tds-u-mt2" style="color:darkgray;">(Click message to hide)</div>
    </tds-message >
</div>
<!------------------------------------Admin-Info-Messages End---------------------------------------------->

<div class="tds-u-p1">
    <app-list-paginator 
        [backgroundColor]="'var(--tds-grey-300)'" 
        [height]="'52px'" 
        [rowsPerPage]="rowsPerPage" 
        [currentPage]="currentPage" 
        [totalPages]="totalPages" 
        (onPaginatorPage)="pageChange($event)"
        (onPageSizeChanged)="pageSizeChange($event)">
    </app-list-paginator> 
    <div class="assignment-table-scroll">
    <tds-table expandable-rows vertical-dividers="false" compact-design="true" responsive no-min-width>
        <!-- <tds-table-toolbar table-title="Filter" filter ></tds-table-toolbar> -->
        <tds-table-header>
            <tds-header-cell sortable cell-key="assignmentNumber"  cell-value="Assignment no" ></tds-header-cell>
            <tds-header-cell sortable cell-key="department" cell-value="Department" ></tds-header-cell>
            <tds-header-cell sortable cell-key="managerName" cell-value="Manager" ></tds-header-cell>
            <tds-header-cell sortable cell-key="assignmentStartdate" cell-value="Assignment start date" ></tds-header-cell>
            <tds-header-cell sortable cell-key="assignmentEndDate" cell-value="Assignment end date" ></tds-header-cell>
            <tds-header-cell cell-value="" ></tds-header-cell>
            <tds-header-cell sortable cell-key="daysLeftToExtend" cell-value="Days left" ></tds-header-cell>
            <tds-header-cell cell-value=""></tds-header-cell>
            <tds-header-cell sortable cell-key="extendDate" cell-value="Extend Date" ></tds-header-cell>
            <tds-header-cell cell-value="" ></tds-header-cell>
            <tds-header-cell sortable cell-key="assignedConsultants" cell-value="Consultants" ></tds-header-cell>
            <tds-header-cell sortable cell-key="nrOfComments" cell-value="Comments" ></tds-header-cell>
            <tds-header-cell sortable cell-key="dispensation" cell-value="Dispensation" *ngIf="this.canGiveDispensation()"></tds-header-cell>
        </tds-table-header>
        <tds-table-body>
            <tds-table-body-row-expandable *ngFor="let assignment of slicedRows" >
                <!-- Assignment number -->
                <tds-body-cell class="tds-u-pt2 tds-u-pb1">
                    {{assignment.assignmentNumber}}
                </tds-body-cell>
                
                <!-- Department -->
                <tds-body-cell class="tds-u-pt2 tds-u-pb1">
                    {{assignment.department}}
                </tds-body-cell>

                <!-- Manager -->
                <tds-body-cell class="tds-u-pt2 tds-u-pb1">
                    <div class="tooltip">
                    {{assignment.managerName}}
                    <div class="tds-detail-05">
                            <span class="tooltiptext">
                                {{assignment.managerName}} ({{assignment.assignmentManager}})
                            </span>   
                        </div>
                    </div>
                </tds-body-cell>

                <!-- Start date -->
                <tds-body-cell class="tds-u-pt2 tds-u-pb1" style="white-space: nowrap;">
                    {{assignment.assignmentStartdate | date:'mediumDate'}}
                </tds-body-cell>

                <!-- End date -->
                <tds-body-cell class="tds-u-pt2 tds-u-pb1" style="white-space: nowrap;">
                    <span *ngIf="isDateSet(assignment.assignmentEndDate);">
                        {{assignment.assignmentEndDate | date:'mediumDate'}}
                    </span>
                    <span *ngIf="!isDateSet(assignment.assignmentEndDate);">
                        ----
                    </span>
                </tds-body-cell>

                <!-- End date icon-->
                <tds-body-cell>
                    <div class="tooltip tds-detail-05" *ngIf="isAllowedToEditEndDate(assignment.assignmentManager)"
                        style="cursor: pointer; "
                        (click)="openEndDateDialog(assignment.assignmentNumber, assignment.department, assignment.assignmentManager, isDateSet(assignment.extendDate))">
                        <svg fill="none" stroke="var(--tds-blue-800" xmlns="http://www.w3.org/2000/svg" width="1.4rem" height="1.4rem" viewBox="0 0 32 32">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M20.348 4.58a2 2 0 0 1 2.828 0l4.242 4.243a2 2 0 0 1 0 2.829L13.672 25.398a2 2 0 0 1-.888.515l-7.521 2.05a1 1 0 0 1-1.228-1.227l2.051-7.521a2 2 0 0 1 .515-.888L20.347 4.58Zm5.656 5.657-4.242-4.242-2.122 2.121 4.243 4.243 2.121-2.122Zm-3.535 3.536L18.226 9.53 8.016 19.74l-1.591 5.834 5.833-1.59 10.21-10.211Z" fill="currentColor"/>
                        </svg>
                        <span class="tooltiptext">
                            Set end date
                        </span>   
                    </div>
                    <div class="tooltip tds-detail-05" *ngIf="!isAllowedToEditEndDate(assignment.assignmentManager)" 
                        style="cursor: pointer; "
                        (click)="openEndDateDialog(assignment.assignmentNumber, assignment.department, assignment.assignmentManager, isDateSet(assignment.extendDate))">
                        <svg fill="none" stroke="var(--tds-blue-800" xmlns="http://www.w3.org/2000/svg" width="1.4rem" height="1.4rem" viewBox="0 0 32 32">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M4.062 16C5.146 18.842 8.855 24 16 24c7.145 0 10.854-5.158 11.938-8C26.854 13.158 23.145 8 16 8 8.855 8 5.146 13.158 4.062 16Zm-2.01-.316C3.131 12.439 7.418 6 16 6c8.58 0 12.867 6.44 13.949 9.684a1 1 0 0 1 0 .632C28.867 19.561 24.58 26 16 26c-8.58 0-12.867-6.44-13.949-9.684a1 1 0 0 1 0-.632Z" fill="currentColor"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M16 13a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm-5 3a5 5 0 1 1 10 0 5 5 0 0 1-10 0Z" fill="currentColor"/>
                        </svg>   
                        <span class="tooltiptext">
                            See Edit History
                        </span>   
                    </div>
                </tds-body-cell>

                <!-- Days left bar -->
                <tds-body-cell>
                    <div style="min-width: 220px; max-width: 300px; position: relative;">
                        <div style="width: 100%; border-radius: 4px; border: grey 1px solid; position: absolute; height: 24px;text-align: center;white-space: nowrap;">
                            <div [style.width]="getBarWidth(assignment)"
                                [style.background-color]="getBarColor(assignment)"
                                style="height: 22px;padding:4px;">&nbsp;
                            </div>
                            <div *ngIf="assignment.daysLeftToExtend > 0 && !isDateSet(assignment.assignmentEndDate) && !isDateSet(assignment.extendDate) && !hasDispensation(assignment)"
                                style="margin-top: -18px; ">{{assignment.daysLeftToExtend}} days left to extend
                            </div>
                            
                            <div *ngIf="assignment.daysLeftToExtend > 0 && !isDateSet(assignment.assignmentEndDate) && isDateSet(assignment.extendDate) && !hasDispensation(assignment)"
                                style="margin-top: -19px; ">{{assignment.daysLeftToExtend}} days left til 2 years passed.
                            </div>       

                            <div *ngIf="isDateSet(assignment.assignmentEndDate) && !isEndDatePassed(assignment.assignmentEndDate) && !hasDispensation(assignment)"
                                style="margin-top: -19px; "> Ends in {{calcDaysLeftFromToday(assignment.assignmentEndDate)}} days
                            </div>

                            <div *ngIf="hasExpired(assignment.daysLeftToExtend, assignment.assignmentEndDate) && !isDateSet(assignment.assignmentEndDate) && !hasDispensation(assignment)"
                                style="margin-top: -19px; color:var(--tds-red-700);">{{daysOverdue(assignment.daysLeftToExtend)}} days overdue!
                            </div>

                            <div *ngIf="isEndDatePassed(assignment.assignmentEndDate)"
                                style="margin-top: -19px; color: var(--tds-red-700);">Assignment has ended
                            </div>

                            <div *ngIf="!isEndDatePassed(assignment.assignmentEndDate) && hasDispensation(assignment)"
                                style="margin-top: -19px; color: var(--tds-white-100);">Dispensation
                            </div>
                        </div>
                    </div>
                </tds-body-cell>

                <!-- Days left icon -->
                <tds-body-cell class="tds-u-pt1">
                    <div *ngIf="isDateSet(assignment.extendDate) && hasExpired(assignment.daysLeftToExtend, assignment.assignmentEndDate) && !isDateSet(assignment.assignmentEndDate) && !hasDispensation(assignment)">
                        <div style="float:left" class="tooltip tds-detail-05">
                            <!-- FUTURE24 -->
                            <svg fill="none" stroke="var(--tds-orange-400)" xmlns="http://www.w3.org/2000/svg" width="2rem" height="2rem" viewBox="0 0 32 32">
                                <g transform="matrix(-1,0,0,1,23.9998,0)">
                                    <path d="M11.998,2.5C8.306,2.5 4.933,4.651 3.378,8L5.75,8C6.161,8 6.5,8.339 6.5,8.75C6.5,9.161 6.161,9.5 5.75,9.5L2,9.5C1.451,9.5 1,9.049 1,8.5L1,4.75C1,4.339 1.339,4 1.75,4C2.161,4 2.5,4.339 2.5,4.75L2.5,6.447C4.47,3.076 8.094,0.998 11.998,1C18.074,1 23,5.925 23,12C23,18.075 18.074,23 11.998,23C6.014,23 1.146,18.223 1,12.275C1,12.269 1,12.263 1,12.257C1,11.845 1.338,11.506 1.75,11.506C2.155,11.506 2.49,11.834 2.5,12.238C2.628,17.358 6.876,21.501 11.998,21.5C17.246,21.5 21.5,17.247 21.5,12C21.5,6.753 17.246,2.5 11.998,2.5Z" style="fill-rule:nonzero;"/>
                                </g>
                                <path d="M12.5,7.25C12.5,6.839 12.161,6.5 11.75,6.5C11.339,6.5 11,6.839 11,7.25L11,12.75C11,13.02 11.144,13.268 11.378,13.401L14.878,15.401C14.988,15.46 15.11,15.491 15.235,15.491C15.646,15.491 15.985,15.153 15.985,14.741C15.985,14.479 15.847,14.235 15.622,14.099L12.5,12.315L12.5,7.25Z" style="fill-rule:nonzero;"/>
                            </svg>
                            <span class="tooltiptext">
                                This assignment has been extended. Counting 2 years from start date.
                            </span>   
                        </div>
                        <div style="float:left" class="tooltip tds-detail-05">
                            <!-- WARNING -->
                            <svg fill="none" stroke="var(--tds-red-400)" xmlns="http://www.w3.org/2000/svg" width="1.4rem" height="1.4rem" viewBox="0 0 32 32">
                                <path d="M14.803 16.47V13h2.376v3.47l-.352 4.295h-1.672l-.352-4.295Zm-.053 5.632h2.5v2.394h-2.5v-2.394Z" fill="currentColor"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M16 2a1 1 0 0 1 .887.539l13 25A1 1 0 0 1 29 29H3a1 1 0 0 1-.887-1.461l13-25A1 1 0 0 1 16 2ZM4.647 27h22.706L16 5.168 4.647 27Z" fill="currentColor"/>
                            </svg>
                            <span class="tooltiptext">
                                This assignment has been ongoing for longer then allowed. It should be assigned an end date.
                            </span>   
                        </div>
                    </div>

                    <div class="tds-u-mr1" style="float:left" *ngIf="isDateSet(assignment.extendDate) && !hasExpired(assignment.daysLeftToExtend, assignment.assignmentEndDate) && !isDateSet(assignment.assignmentEndDate) && !hasDispensation(assignment)">
                        <div class="tooltip tds-detail-05">
                            <!-- FUTURE24 -->
                            <svg fill="none" stroke="var(--tds-orange-400)" xmlns="http://www.w3.org/2000/svg" width="1.4rem" height="1.4rem" viewBox="0 0 24 24">
                                <g transform="matrix(-1,0,0,1,23.9998,0)">
                                    <path d="M11.998,2.5C8.306,2.5 4.933,4.651 3.378,8L5.75,8C6.161,8 6.5,8.339 6.5,8.75C6.5,9.161 6.161,9.5 5.75,9.5L2,9.5C1.451,9.5 1,9.049 1,8.5L1,4.75C1,4.339 1.339,4 1.75,4C2.161,4 2.5,4.339 2.5,4.75L2.5,6.447C4.47,3.076 8.094,0.998 11.998,1C18.074,1 23,5.925 23,12C23,18.075 18.074,23 11.998,23C6.014,23 1.146,18.223 1,12.275C1,12.269 1,12.263 1,12.257C1,11.845 1.338,11.506 1.75,11.506C2.155,11.506 2.49,11.834 2.5,12.238C2.628,17.358 6.876,21.501 11.998,21.5C17.246,21.5 21.5,17.247 21.5,12C21.5,6.753 17.246,2.5 11.998,2.5Z" style="fill-rule:nonzero;"/>
                                </g>
                                <path d="M12.5,7.25C12.5,6.839 12.161,6.5 11.75,6.5C11.339,6.5 11,6.839 11,7.25L11,12.75C11,13.02 11.144,13.268 11.378,13.401L14.878,15.401C14.988,15.46 15.11,15.491 15.235,15.491C15.646,15.491 15.985,15.153 15.985,14.741C15.985,14.479 15.847,14.235 15.622,14.099L12.5,12.315L12.5,7.25Z" style="fill-rule:nonzero;"/>
                            </svg>
                            <span class="tooltiptext">
                                This assignment has been extended. Counting 2 years from start date.
                            </span>   
                        </div>
                    </div>

                    <div class="tds-u-mr1" style="float:left" *ngIf="hasExpired(assignment.daysLeftToExtend, assignment.assignmentEndDate) && !isDateSet(assignment.assignmentEndDate) && !isDateSet(assignment.extendDate) && !hasDispensation(assignment)">
                        <div class="tooltip tds-detail-05">
                            <!-- WARNING -->
                            <svg fill="none" stroke="var(--tds-red-400)" xmlns="http://www.w3.org/2000/svg" width="1.4rem" height="1.4rem" viewBox="0 0 32 32">
                                <path d="M14.803 16.47V13h2.376v3.47l-.352 4.295h-1.672l-.352-4.295Zm-.053 5.632h2.5v2.394h-2.5v-2.394Z" fill="currentColor"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M16 2a1 1 0 0 1 .887.539l13 25A1 1 0 0 1 29 29H3a1 1 0 0 1-.887-1.461l13-25A1 1 0 0 1 16 2ZM4.647 27h22.706L16 5.168 4.647 27Z" fill="currentColor"/>
                            </svg>
                            <span class="tooltiptext">
                                This assignment has been ongoing for longer then allowed. It should be assigned an end date or be extended.
                            </span>   
                        </div>
                    </div>                    

                    <div class="tds-u-mr1" style="float:left" *ngIf="isDateSet(assignment.assignmentEndDate) && !isEndDatePassed(assignment.assignmentEndDate)">
                        <div class="tooltip tds-detail-05">
                            <!-- CALENDAR -->
                            <svg fill="none" stroke="var(--tds-blue-600)" xmlns="http://www.w3.org/2000/svg" width="1.4rem" height="1.4rem" viewBox="0 0 32 32">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M23.625 2.977a1 1 0 1 0-2 0v2.985l-11.344.01V2.99a1 1 0 1 0-2 0v2.985H6.25a4.2 4.2 0 0 0-4.2 4.2V25.77a4.2 4.2 0 0 0 4.2 4.2h19.54a4.2 4.2 0 0 0 4.2-4.2V10.167a4.2 4.2 0 0 0-4.191-4.2l-2.174-.004V2.977ZM4.05 10.174a2.2 2.2 0 0 1 2.2-2.2l16.376-.013 3.17.006a2.2 2.2 0 0 1 2.195 2.2v1.847H4.05l-.001-1.84Zm0 3.84V25.77a2.2 2.2 0 0 0 2.2 2.2h19.54a2.2 2.2 0 0 0 2.2-2.2V14.014H4.05Z" fill="currentColor"/>
                            </svg>
                            <span class="tooltiptext">
                                End date has been set
                            </span>   
                        </div>
                    </div>    

                    <div class="tds-u-mr1" *ngIf="isEndDatePassed(assignment.assignmentEndDate)" style="float:left" >
                        <div class="tooltip tds-detail-05">
                            <!-- CALENDAR INACTIVE -->
                            <svg fill="none" stroke="var(--tds-grey-600)" xmlns="http://www.w3.org/2000/svg" width="1.4rem" height="1.4rem" viewBox="0 0 32 32">
                                <path d="M30 25.473V10a4 4 0 0 0-4-4h-2V3a1 1 0 1 0-2 0v3H10.527l2 2H26a2 2 0 0 1 2 2v2H16.527l2 2H28v9.473l2 2ZM10.042 14H4v12a2 2 0 0 0 2 2h18.042l2 2H6a4 4 0 0 1-4-4V10c0-1.115.456-2.124 1.193-2.85l1.414 1.415A1.994 1.994 0 0 0 4 10v2h4.042l2 2ZM8 3.473l2 2V3a1 1 0 0 0-2 0v.473Z" fill="currentColor"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M2.293 2.293a1 1 0 0 1 1.414 0l26 26a1 1 0 0 1-1.414 1.414l-26-26a1 1 0 0 1 0-1.414Z" fill="currentColor"/>
                            </svg>
                            <span class="tooltiptext">
                                End date has passed
                            </span>   
                        </div>
                    </div>                    

                    <div style="float:left;" *ngIf="hasDispensation(assignment) && !isEndDatePassed(assignment.assignmentEndDate)">
                        <div class="tooltip tds-detail-05">
                            <!-- TICK -->
                            <svg fill="none" stroke="var(--tds-grey-600)" xmlns="http://www.w3.org/2000/svg" width="1.4rem" height="1.4rem" viewBox="0 0 32 32">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M27.744 8.48a1 1 0 0 1 .004 1.413 2709.096 2709.096 0 0 1-9.899 9.909 1642.18 1642.18 0 0 0-4.806 4.805 1 1 0 0 1-1.416.001l-7.355-7.362a1 1 0 0 1 1.415-1.414l6.646 6.653a2024.31 2024.31 0 0 1 5.35-5.342c2.362-2.356 5.155-5.146 8.647-8.66a1 1 0 0 1 1.414-.004Z" fill="currentColor"/>
                            </svg>
                            <span class="tooltiptext">
                                This assignment has been given dispensation from system admin to be ongoing for longer then allowed
                            </span>   
                        </div>
                    </div>                    
                </tds-body-cell>
                
                <!-- Extend date -->
                <tds-body-cell class="tds-u-pt2 tds-u-pb1" style="white-space: nowrap;">
                    {{assignment.extendDate | date:'mediumDate'}}
                </tds-body-cell>

                <!-- Extend date icon -->
                <tds-body-cell>
                    <div class="tooltip tds-detail-05" 
                        style="cursor: pointer; "
                        (click)="openExtendDateDialog(assignment.assignmentNumber, assignment.department, assignment.assignmentManager, isDateSet(assignment.extendDate))"
                        *ngIf="isAllowedToEditExtendDate(assignment.assignmentManager)">
                        <!-- CLOCK-->
                        <svg fill="none" stroke="var(--tds-blue-700)" xmlns="http://www.w3.org/2000/svg" width="1.4rem" height="1.4rem" viewBox="0 0 32 32">
                            <path d="M17 7a1 1 0 1 0-2 0v8a2 2 0 0 0 2 2h6a1 1 0 1 0 0-2h-6V7Z" fill="currentColor"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M16 2C8.268 2 2 8.268 2 16s6.268 14 14 14 14-6.268 14-14S23.732 2 16 2ZM4 16C4 9.373 9.373 4 16 4s12 5.373 12 12-5.373 12-12 12S4 22.627 4 16Z" fill="currentColor"/>
                        </svg>
                        <span class="tooltiptext">
                            Extend date
                        </span>   
                    </div>
                    <div class="tooltip tds-detail-05" 
                        style="cursor: pointer; "
                        (click)="openExtendDateDialog(assignment.assignmentNumber, assignment.department, assignment.assignmentManager, isDateSet(assignment.extendDate))"
                        *ngIf="!isAllowedToEditExtendDate(assignment.assignmentManager)" >
                        <!--EYE-->
                        <svg fill="none" stroke="var(--tds-blue-800" xmlns="http://www.w3.org/2000/svg" width="1.4rem" height="1.4rem" viewBox="0 0 32 32">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M4.062 16C5.146 18.842 8.855 24 16 24c7.145 0 10.854-5.158 11.938-8C26.854 13.158 23.145 8 16 8 8.855 8 5.146 13.158 4.062 16Zm-2.01-.316C3.131 12.439 7.418 6 16 6c8.58 0 12.867 6.44 13.949 9.684a1 1 0 0 1 0 .632C28.867 19.561 24.58 26 16 26c-8.58 0-12.867-6.44-13.949-9.684a1 1 0 0 1 0-.632Z" fill="currentColor"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M16 13a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm-5 3a5 5 0 1 1 10 0 5 5 0 0 1-10 0Z" fill="currentColor"/>
                        </svg>   
                        <span class="tooltiptext">
                            See Edit History
                        </span>   
                    </div>   
                </tds-body-cell>

                <!-- Number of consultants -->
                <tds-body-cell>
                    <span *ngIf="assignment.assignedConsultants.length > 0 ">
                        <span class="tooltip tds-detail-05" *ngFor="let cons of orderConsultantsByActiveStatus(assignment.assignedConsultants)">
                            <!--PROFILE-->
                            <svg *ngIf="isConsultantActive(cons.consultantEnddate)" fill="none" stroke="var(--tds-green-300)" xmlns="http://www.w3.org/2000/svg" width="1.35rem" height="1.35rem" viewBox="0 0 32 32">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M16 3.98a6.642 6.642 0 1 0 0 13.283 6.642 6.642 0 0 0 0-13.284ZM7.358 10.62a8.642 8.642 0 1 1 17.284 0 8.642 8.642 0 0 1-17.284 0ZM1.994 28.387a7.4 7.4 0 0 1 7.4-7.4h13.212a7.4 7.4 0 0 1 7.4 7.4v.625a1 1 0 1 1-2 0v-.625a5.4 5.4 0 0 0-5.4-5.4H9.394a5.4 5.4 0 0 0-5.4 5.4v.625a1 1 0 1 1-2 0v-.625Z" fill="currentColor"/>
                            </svg>   

                            <!--PROFILE-->
                            <svg *ngIf="!isConsultantActive(cons.consultantEnddate)" fill="none" stroke="var(--tds-red-400)" xmlns="http://www.w3.org/2000/svg" width="1.35rem" height="1.35rem" viewBox="0 0 32 32">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M16 3.98a6.642 6.642 0 1 0 0 13.283 6.642 6.642 0 0 0 0-13.284ZM7.358 10.62a8.642 8.642 0 1 1 17.284 0 8.642 8.642 0 0 1-17.284 0ZM1.994 28.387a7.4 7.4 0 0 1 7.4-7.4h13.212a7.4 7.4 0 0 1 7.4 7.4v.625a1 1 0 1 1-2 0v-.625a5.4 5.4 0 0 0-5.4-5.4H9.394a5.4 5.4 0 0 0-5.4 5.4v.625a1 1 0 1 1-2 0v-.625Z" fill="currentColor"/>
                            </svg>   
                            
                            <span class="tooltiptext">
                                {{getPersonTooltip(assignment.assignedConsultants)}}
                            </span>            
                        </span>
                    </span>

                    <span class="tooltip tds-detail-05" *ngIf="assignment.assignedConsultants.length == 0 ">
                        <!--PROFILE INACTIVE-->
                        <svg fill="none" stroke="var(--tds-grey-700);" xmlns="http://www.w3.org/2000/svg" width="1.35rem" height="1.35rem" viewBox="0 0 32 32">
                            <path d="M24.648 10.642a8.624 8.624 0 0 1-3.117 6.646l-1.422-1.422a6.642 6.642 0 1 0-9.326-9.326L9.36 5.118a8.642 8.642 0 0 1 15.288 5.524ZM7.424 11.667a8.646 8.646 0 0 0 7.557 7.557l-7.557-7.557ZM9.397 20.975h7.335l2 2H9.397A5.399 5.399 0 0 0 4 28.375V29a1 1 0 1 1-2 0v-.625c0-4.087 3.312-7.4 7.397-7.4ZM3.707 2.293a1 1 0 0 0-1.414 1.414l26 26a1 1 0 0 0 1.414-1.414l-26-26Z" fill="currentColor"/>
                        </svg>             
                        <span class="tooltiptext">
                            {{getPersonTooltip(assignment.assignedConsultants)}}
                        </span>
                    </span>
                </tds-body-cell>

                <!-- Comments -->
                <tds-body-cell>
                    <div id="{{assignment.assignmentNumber}}" 
                        class="tooltip tds-detail-05"
                        style="cursor: pointer;"
                        (click)="openCommentDialog(assignment.assignmentNumber, assignment.department, assignment.assignmentManager)"
                        *ngIf="assignment.nrOfComments > 0">
                        <!--MESSAGE-->
                        <svg fill="none" stroke="var(--tds-grey-900)" xmlns="http://www.w3.org/2000/svg" width="1.4rem" height="1.4rem" viewBox="0 0 32 32">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.154 5.998h19.527c1.215 0 2.2.986 2.2 2.201v10.965a2.201 2.201 0 0 1-2.2 2.201l-3.951.001H9.954v.047a1.005 1.005 0 0 0-.24.114l-5.742 3.72-.018-4.945V8.198a2.2 2.2 0 0 1 2.2-2.2Zm-4.2 14.307v1.197h.005l.019 5.584a1 1 0 0 0 1.544.836l7.031-4.556H21.73l3.953-.001a4.201 4.201 0 0 0 4.198-4.201V8.199a4.201 4.201 0 0 0-4.2-4.201H6.154a4.2 4.2 0 0 0-4.2 4.2V19.81a1.01 1.01 0 0 0-.001.06l.001.435Z" fill="currentColor"/>
                        </svg>   

                        <tds-badge class="badge-position" value="{{assignment.nrOfComments}}" size="md"></tds-badge>     
                        
                        <span class="tooltiptext">
                            {{assignment.nrOfComments}} comments on this assignment. <br>Click to add/remove comment.
                        </span>
                    </div>        

                    <div id="{{assignment.assignmentNumber}}" 
                        class="tooltip tds-detail-05"
                        style="cursor: pointer;color: var(--tds-grey-600);"
                        (click)="openCommentDialog(assignment.assignmentNumber, assignment.department, assignment.assignmentManager)"
                        *ngIf="assignment.nrOfComments == 0">
                        <!--MESSAGE-->
                        <svg fill="none" stroke="var(--tds-grey-700)" xmlns="http://www.w3.org/2000/svg" width="1.4rem" height="1.4rem" viewBox="0 0 32 32">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.154 5.998h19.527c1.215 0 2.2.986 2.2 2.201v10.965a2.201 2.201 0 0 1-2.2 2.201l-3.951.001H9.954v.047a1.005 1.005 0 0 0-.24.114l-5.742 3.72-.018-4.945V8.198a2.2 2.2 0 0 1 2.2-2.2Zm-4.2 14.307v1.197h.005l.019 5.584a1 1 0 0 0 1.544.836l7.031-4.556H21.73l3.953-.001a4.201 4.201 0 0 0 4.198-4.201V8.199a4.201 4.201 0 0 0-4.2-4.201H6.154a4.2 4.2 0 0 0-4.2 4.2V19.81a1.01 1.01 0 0 0-.001.06l.001.435Z" fill="currentColor"/>
                        </svg>       
                        <span class="tooltiptext">
                            There is no comments on this assignment. <br>Click to add comment.
                        </span>
                    </div>        
                </tds-body-cell>

                <!-- Dispensation -->
                <tds-body-cell *ngIf="this.canGiveDispensation()">
                    <span class="tooltip tds-detail-05"   
                        style="cursor: pointer;"
                        (click)="openDispensationDialog(assignment.assignmentNumber, false)"
                        *ngIf="!(hasDispensation(assignment) && !isEndDatePassed(assignment.assignmentEndDate))">
                        <!--PLUS-->
                        <svg fill="none" stroke="var(--tds-green-300)" xmlns="http://www.w3.org/2000/svg" width="1.4rem" height="1.4rem" viewBox="0 0 32 32">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M17 4.98a1 1 0 1 0-2 0V15H4.98a1 1 0 0 0 0 2H15v10.02a1 1 0 0 0 2 0V17h10.02a1 1 0 1 0 0-2H17V4.98Z" fill="currentColor"/>
                        </svg> 
                        <span class="tooltiptext">
                            Give dispensation to this assignment
                        </span>      
                    </span>

                    <span class="tooltip tds-detail-05"  
                        style="cursor: pointer;"
                        (click)="openDispensationDialog(assignment.assignmentNumber, true)"
                        *ngIf="hasDispensation(assignment) && !isEndDatePassed(assignment.assignmentEndDate)" >
                        <!--MINUS-->
                        <svg fill="none" stroke="var(--tds-red-400)" xmlns="http://www.w3.org/2000/svg" width="1.4rem" height="1.4rem" viewBox="0 0 32 32">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.98 16a1 1 0 0 1 1-1h22.04a1 1 0 0 1 0 2H4.98a1 1 0 0 1-1-1Z" fill="currentColor"/>
                        </svg>    
                        <span class="tooltiptext">
                            Remove dispensation from this assignment
                        </span>   
                    </span>
                </tds-body-cell>

                <div slot="expand-row">
                    <div *ngIf="assignment.assignedConsultants.length == 0">
                        No consultants on this assignment
                    </div>
                    <div class="tds-row">
                        <div class="tds-col-xs-4 info-card {{isConsultantActive(consultant.consultantEnddate) ? 'info-card-border-green' : 'info-card-border-red'}}" 
                            *ngFor="let consultant of assignment.assignedConsultants">
                            <div class="tds-col-xs-12 tds-u-pb1">
                                <div class="tds-u-p1" *ngIf="isConsultantActive(consultant.consultantEnddate)"  
                                    class="tds-row tds-u-pt1 info-card-top-green">
                                    <div class="tds-col-xs-1" >
                                        <svg fill="none" stroke="var(--tds-green-400)" xmlns="http://www.w3.org/2000/svg" width="1.4rem" height="1.4rem" viewBox="0 0 32 32">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M16.013 4.004c-6.642 0-12.026 5.384-12.026 12.025 0 6.642 5.384 12.026 12.026 12.026 6.641 0 12.025-5.384 12.025-12.026 0-6.641-5.384-12.025-12.025-12.025ZM1.987 16.029c0-7.746 6.28-14.025 14.026-14.025 7.746 0 14.025 6.28 14.025 14.025 0 7.746-6.28 14.026-14.025 14.026-7.746 0-14.026-6.28-14.026-14.026Z" fill="currentColor"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M16.025 14.126a1 1 0 0 1 1 1v5.616a1 1 0 0 1-2 0v-5.616a1 1 0 0 1 1-1ZM16.025 10.317a1 1 0 0 1 1 1v.217a1 1 0 1 1-2 0v-.217a1 1 0 0 1 1-1Z" fill="currentColor"/>
                                        </svg>
                                    </div>    
                                    <div class="tds-col-xs-1 tds-headline-05 info-card-header-text-green">ACTIVE</div>
                                </div>

                                <div class="tds-u-p1" *ngIf="!isConsultantActive(consultant.consultantEnddate)"  
                                    class="tds-row tds-u-pt1 info-card-top-red">
                                    <div class="tds-col-xs-1" >
                                        <svg fill="none" stroke="var(--tds-red-400)" xmlns="http://www.w3.org/2000/svg" width="1.4rem" height="1.4rem" viewBox="0 0 32 32">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M16.013 4.004c-6.642 0-12.026 5.384-12.026 12.025 0 6.642 5.384 12.026 12.026 12.026 6.641 0 12.025-5.384 12.025-12.026 0-6.641-5.384-12.025-12.025-12.025ZM1.987 16.029c0-7.746 6.28-14.025 14.026-14.025 7.746 0 14.025 6.28 14.025 14.025 0 7.746-6.28 14.026-14.025 14.026-7.746 0-14.026-6.28-14.026-14.026Z" fill="currentColor"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M16.025 14.126a1 1 0 0 1 1 1v5.616a1 1 0 0 1-2 0v-5.616a1 1 0 0 1 1-1ZM16.025 10.317a1 1 0 0 1 1 1v.217a1 1 0 1 1-2 0v-.217a1 1 0 0 1 1-1Z" fill="currentColor"/>
                                        </svg>
                                    </div>    
                                    <div class="tds-col-xs-1 tds-headline-05 info-card-header-text-red">INACTIVE</div>
                                </div>

                                <div class="tds-row tds-u-p1 info-card-divider">
                                    {{getConsultantInfoMsg(consultant)}}
                                </div>

                                <div class="tds-row tds-u-pt1 info-card-divider">
                                    <div class="tds-col-xs-5 tds-headline-07" >Consultant Name:</div>
                                    <div class="tds-col-xs-7 tds-detail-01">{{consultant.consultantName}}</div>
                                </div>

                                <div class="tds-row tds-u-pt1 info-card-divider">
                                    <div class="tds-col-xs-5 tds-headline-07" >Consultant Number:</div>
                                    <div class="tds-col-xs-7 tds-detail-01">{{consultant.consultantNumber}}</div>
                                </div>

                                <div class="tds-row tds-u-pt1 info-card-divider">
                                    <div class="tds-col-xs-5 tds-headline-07" >Reason for Employee Need:</div>
                                    <div class="tds-col-xs-7 tds-detail-01">{{consultant.reasonForEmplNeed}}</div>
                                </div>

                                <div class="tds-row tds-u-pt1 info-card-divider">
                                    <div class="tds-col-xs-5 tds-headline-07" >Consultant Start Date:</div>
                                    <div class="tds-col-xs-7 tds-detail-01">{{consultant.consultantStartdate | date:'mediumDate'}}</div>
                                </div>

                                <div class="tds-row tds-u-pt1 info-card-divider" *ngIf="isDateSet(consultant.consultantEnddate)">
                                    <div class="tds-col-xs-5 tds-headline-07" >Consultant End Date:</div>
                                    <div class="tds-col-xs-7 tds-detail-01">{{consultant.consultantEnddate | date:'mediumDate'}}</div>
                                </div>

                                <div class="tds-row tds-u-pt1 info-card-divider" *ngIf="!isDateSet(consultant.consultantEnddate)">
                                    <div class="tds-col-xs-5 tds-headline-07" >Consultant Date:</div>
                                    <div class="tds-col-xs-7 tds-detail-01">No date set</div>
                                </div>

                                <div class="tds-row tds-u-pt1 info-card-divider">
                                    <div class="tds-col-xs-5 tds-headline-07" >Unit Number:</div>
                                    <div class="tds-col-xs-7 tds-detail-01">{{consultant.unitNumber}}</div>
                                </div>

                                <div class="tds-row tds-u-pt1" >
                                    <div class="tds-col-xs-5 tds-headline-07" >Other Assignments Associated:</div>
                                    <div class="tds-col-xs-7 tds-detail-01">
                                        <div *ngIf="getConsultantsOtherAssignments(consultant).length == 0;">
                                            No other assignments.
                                        </div>
                                        <div  *ngIf="getConsultantsOtherAssignments(consultant).length == 0;">
                                            <div *ngFor="let consRecord of getConsultantsOtherAssignments(consultant)">
                                                {{consRecord.assignmentNumber}}
                                                <svg *ngIf="isConsultantActive(consRecord.consultantEnddate)" fill="none" stroke="var(--tds-green-400)" xmlns="http://www.w3.org/2000/svg" width="1.4rem" height="1.4rem" viewBox="0 0 32 32">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.013 4.004c-6.642 0-12.026 5.384-12.026 12.025 0 6.642 5.384 12.026 12.026 12.026 6.641 0 12.025-5.384 12.025-12.026 0-6.641-5.384-12.025-12.025-12.025ZM1.987 16.029c0-7.746 6.28-14.025 14.026-14.025 7.746 0 14.025 6.28 14.025 14.025 0 7.746-6.28 14.026-14.025 14.026-7.746 0-14.026-6.28-14.026-14.026Z" fill="currentColor"/>
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.025 14.126a1 1 0 0 1 1 1v5.616a1 1 0 0 1-2 0v-5.616a1 1 0 0 1 1-1ZM16.025 10.317a1 1 0 0 1 1 1v.217a1 1 0 1 1-2 0v-.217a1 1 0 0 1 1-1Z" fill="currentColor"/>
                                                </svg>
                                                <svg *ngIf="!isConsultantActive(consRecord.consultantEnddate)" fill="none" stroke="var(--tds-re-400)" xmlns="http://www.w3.org/2000/svg" width="1.4rem" height="1.4rem" viewBox="0 0 32 32">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.013 4.004c-6.642 0-12.026 5.384-12.026 12.025 0 6.642 5.384 12.026 12.026 12.026 6.641 0 12.025-5.384 12.025-12.026 0-6.641-5.384-12.025-12.025-12.025ZM1.987 16.029c0-7.746 6.28-14.025 14.026-14.025 7.746 0 14.025 6.28 14.025 14.025 0 7.746-6.28 14.026-14.025 14.026-7.746 0-14.026-6.28-14.026-14.026Z" fill="currentColor"/>
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.025 14.126a1 1 0 0 1 1 1v5.616a1 1 0 0 1-2 0v-5.616a1 1 0 0 1 1-1ZM16.025 10.317a1 1 0 0 1 1 1v.217a1 1 0 1 1-2 0v-.217a1 1 0 0 1 1-1Z" fill="currentColor"/>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </tds-table-body-row-expandable>
        </tds-table-body>
        <!-- <tds-table-footer cols="14" *ngIf="this.canGiveDispensation()" pages="{{totalPages}}" pagination></tds-table-footer>
        <tds-table-footer cols="13" *ngIf="!this.canGiveDispensation()" pages="{{totalPages}}" pagination></tds-table-footer> -->
    </tds-table>
    </div>
    <app-list-paginator 
        [backgroundColor]="'var(--tds-grey-100)'" 
        [height]="'52px'" 
        [rowsPerPage]="rowsPerPage" 
        [currentPage]="currentPage" 
        [totalPages]="totalPages" 
        (onPaginatorPage)="pageChange($event)"
        (onPageSizeChanged)="pageSizeChange($event)">
    </app-list-paginator> 
</div>

<div *ngIf="noAssignmentsToShow && !IsNoAssignmentsToShowInUsersDept()" style="position: relative; text-align: center; margin-top: 100px; font-size: 25px; color: #041e42;">
    No assignments was found.<br>
    No records were found given the active searches/filters. Please check that your searches/checkboxes are correct.
</div>

<div *ngIf="IsNoAssignmentsToShowInUsersDept()" style="position: relative; text-align: center; margin-top: 100px; font-size: 25px; color: #041e42;">
    No assignments was found in your department or child-departments.<br>
    Uncheck 'Hide Other Departments' to see assignments in other departments.
</div>
<!------------------------- Table End --------------------------------------------->
<app-toaster></app-toaster>

<app-str-spinner [message]="'Please wait, data is being loaded'"></app-str-spinner>

<comment-dialog *ngIf="dlgType=='commentdlg'" 
  [showMe]="dlgType=='commentdlg'"  
  [addedCommentsCount]="dlgAddedCommentsCount"
  [assignmentNumber]="dlgAssignmentNumber" 
  [department]="dlgDepartment"
  [assignmentManager]="dlgAssignmentManager"
  (onCloseDlg)="onCloseDlg($event)">
</comment-dialog>
  
<extend-date-dialog *ngIf="dlgType=='extenddatedlg'" 
  [showMe]="dlgType=='extenddatedlg'"  
  [isDateSet]="dlgIsDateSet"
  [assignmentNumber]="dlgAssignmentNumber" 
  [department]="dlgDepartment"
  [assignmentManager]="dlgAssignmentManager"
  (onCloseDlg)="onCloseDlg($event)">
</extend-date-dialog>
    
<end-date-dialog *ngIf="dlgType=='enddatedlg'" 
  [showMe]="dlgType=='enddatedlg'"  
  [isDateSet]="dlgIsDateSet"
  [assignmentNumber]="dlgAssignmentNumber" 
  [department]="dlgDepartment"
  [assignmentManager]="dlgAssignmentManager"
  (onCloseDlg)="onCloseDlg($event)">
</end-date-dialog>

<app-dispensation *ngIf="dlgType=='dispensationdlg'" 
  [showMe]="dlgType=='dispensationdlg'"  
  [assignmentNumber]="dlgAssignmentNumber" 
  [hasDispensation]="dlgHasDispensation" 
  (onCloseDlg)="onCloseDlg($event)">
</app-dispensation>
  
<sysadmin-dialog *ngIf="dlgType=='sysadmindlg'" 
  [showMe]="dlgType=='sysadmindlg'"  
  (onCloseDlg)="onCloseDlg($event)">
</sysadmin-dialog>
  
<expired-assignments-dialog *ngIf="dlgType=='expiredassignmentdlg'" 
  [showMe]="dlgType=='expiredassignmentdlg'"  
  (onCloseDlg)="onCloseDlg($event)">
</expired-assignments-dialog>

<active-cons-on-inactive-assign-dialog *ngIf="dlgType2=='activeconsoninactivedlg'" 
  [showMe]="dlgType2=='activeconsoninactivedlg'"
  (onCloseDlg)="onCloseDlg($event)">
</active-cons-on-inactive-assign-dialog>
